import { toTranslateAudoVideoFormats } from "./toTranslateAudoVideoFormats";

export const getVideoFormats = t => {
  const videoElement = document.createElement("video");

  const formatsToCheck = [
    'video/mp4; codecs="flac"',
    'video/ogg; codecs="theora"',
    'video/ogg; codecs="opus"',
    'video/webm; codecs="vp9, opus"',
    'video/webm; codecs="vp8, vorbis"',
  ];

  const videoFormats = formatsToCheck.map(format => ({
    id: format,
    description:
      toTranslateAudoVideoFormats(videoElement.canPlayType(format), t) ||
      t("global.notSupported"),
  }));

  return { videoFormats };
};
